module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "teak.bfae0c9d.svg";